import { render, staticRenderFns } from "./Acsess.vue?vue&type=template&id=48a60fc5&scoped=true&"
import script from "./Acsess.vue?vue&type=script&lang=js&"
export * from "./Acsess.vue?vue&type=script&lang=js&"
import style0 from "./Acsess.vue?vue&type=style&index=0&id=48a60fc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a60fc5",
  null
  
)

export default component.exports